export type SummaryChangeTone = 'positive' | 'negative' | 'neutral';

export interface SummaryChangeDisplay {
    text: string;
    tone: SummaryChangeTone;
}

/**
 * Format summary-card comparison text and color tone.
 * - Missing backend change → no comparison display
 * - Zero change → neutral value, no directional arrow
 */
export function formatSummaryMetricChange(
    changeValue: number | undefined,
    options: {
        suffix: 'pp' | '%';
        isNegativeMetric?: boolean;
        comparisonEnabled: boolean;
    },
): SummaryChangeDisplay | undefined {
    if (!options.comparisonEnabled) return undefined;

    if (changeValue === undefined || changeValue === null) return undefined;

    if (changeValue === 0) {
        return { text: `0.0${options.suffix}`, tone: 'neutral' };
    }

    const isIncrease = changeValue > 0;
    const isGood = options.isNegativeMetric ? !isIncrease : isIncrease;

    return {
        text: `${Math.abs(changeValue).toFixed(1)}${options.suffix}`,
        tone: isGood ? 'positive' : 'negative',
    };
}

export function summaryChangeArrow(tone: SummaryChangeTone): string {
    if (tone === 'positive') return '↗ ';
    if (tone === 'negative') return '↘ ';
    return '';
}

export function summaryChangeColor(tone: SummaryChangeTone): string {
    if (tone === 'positive') return 'green.400';
    if (tone === 'negative') return 'red.400';
    return 'gray.400';
}
